import React from 'react'
import { Link } from 'react-router-dom'
import Faq from './Faq'
import Safe from './Safe'
import WhyChoose from './WhyChoose'

const VideoTranslation = () => {
  return (
    <>
      <div className="banner-allpage-sec">
        <ul className="breadcrumb">
          <li><Link to="/audio/">Home</Link></li>
          <li>Translation</li>
          <li>Video Translation</li>
        </ul>
        <div className="banner-content-sec text-center">
          <h2 className="first-head">Video Translation</h2>
          <h3 className="second-head"></h3>
        </div>
      </div>
      <Safe />
      <WhyChoose />
      <Faq />
    </>
  )
}

export default VideoTranslation